"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntrypointType = void 0;
var EntrypointType;
(function (EntrypointType) {
    EntrypointType["DRPicaso"] = "DRPicaso";
    EntrypointType["USD"] = "USD";
    EntrypointType["CCDev"] = "CCDev";
    EntrypointType["AssistedLogin"] = "AssistedLogin";
})(EntrypointType || (exports.EntrypointType = EntrypointType = {}));
//# sourceMappingURL=types.js.map